// extracted by mini-css-extract-plugin
export var carrierIcon = "_xg-0";
export var carrierLogo = "_xg-1";
export var detailsSection = "_xg-2";